// "Tavut tekstissä": syllables in the running text of the lessons and in Kääntäjä's output
// (docs/next/fb-syllables-everywhere.md; the users' feedback of 2026-10-12). Off by default; per
// person on this device (the key carries the user id, like Harjoitusvauhti in lib/prefs.ts), so
// Roosa's choice on a shared PC is not Axel's. One shared state: Asetukset, Pika-asetukset and
// every open page follow a change at once.
import { useCallback, useSyncExternalStore } from 'react';
import { useApp } from '../state/store';

const key = (userId: string) => `valyrio:syllables:${userId || 'me'}`;

const listeners = new Set<() => void>();
let version = 0;

export function syllablesPref(userId: string): boolean {
  try {
    return localStorage.getItem(key(userId)) === 'on';
  } catch {
    return false;
  }
}

export function setSyllablesPref(userId: string, on: boolean): void {
  try {
    if (on) localStorage.setItem(key(userId), 'on');
    else localStorage.removeItem(key(userId));
  } catch {
    // not stored: off next time
  }
  version++;
  for (const l of listeners) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

/** The person's choice and its setter. */
export function useSyllablesPref(): [boolean, (on: boolean) => void] {
  const meId = useApp((s) => s.me.id);
  // version: re-read after a change in this tab (the value itself is read from storage)
  const on = useSyncExternalStore(
    subscribe,
    () => `${version}:${syllablesPref(meId) ? 1 : 0}`,
    () => '0:0',
  ).endsWith(':1');
  const set = useCallback((v: boolean) => setSyllablesPref(meId, v), [meId]);
  return [on, set];
}
